import { render, staticRenderFns } from "./CreatePickl.vue?vue&type=template&id=ded96846&scoped=true&"
import script from "./CreatePickl.vue?vue&type=script&lang=js&"
export * from "./CreatePickl.vue?vue&type=script&lang=js&"
import style0 from "./CreatePickl.vue?vue&type=style&index=0&id=ded96846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded96846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ded96846')) {
      api.createRecord('ded96846', component.options)
    } else {
      api.reload('ded96846', component.options)
    }
    module.hot.accept("./CreatePickl.vue?vue&type=template&id=ded96846&scoped=true&", function () {
      api.rerender('ded96846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/CreatePickl.vue"
export default component.exports